import { Tabs } from '@mui/material';
import { node } from 'prop-types';
import React from 'react';
import { useLocation, useNavigate } from 'react-router';

const tabsSx = theme => ({
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    margin: '0 auto',
  },
  flexGrow: 1,
});

const resolveTabValue = (pathname, children) => {
  const tabValues = React.Children.toArray(children)
    .map(child => child?.props?.value)
    .filter(Boolean);
  const direct = tabValues.find(value => pathname === value || pathname.startsWith(`${value}/`));
  if (direct) return direct;
  const normalized = pathname.replace(/\/home\/([^/]+)\/.*$/, '/home/$1');
  if (tabValues.includes(normalized)) return normalized;
  return false;
};

const HeaderTabs = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const onChangeTab = (e, value) => {
    if (value) navigate(value);
  };
  return (
    <Tabs
      value={resolveTabValue(location.pathname, children)}
      onChange={onChangeTab}
      indicatorColor="primary"
      sx={tabsSx}
      centered
    >
      {children}
    </Tabs>
  );
};

HeaderTabs.propTypes = {
  children: node.isRequired,
};
export default HeaderTabs;
